export default {
    apiUrl: {
        //导购管理
        guideUrl: {
            insertGuiderInfo: "guider/mgmt/task/insertGuiderTaskShowInfo", //添加任务详情
            getGuiderInfo: "/guider/mgmt/task/selectGuiderTaskShowInfoById", //获取任务详情
            getTaskInfo: "/guider/mgmt/task/selectGuiderTaskInfoById", //获取任务信息
            updateGuiderInfo: "guider/mgmt/task/updateGuiderTaskShowInfo",//修改任务详情
            getTaskList: "guider/mgmt/task/selectGuiderTaskInfoList",//获取任务列表
            updateOnLine:"/guider/mgmt/task/updateOnLine",//修改上线/下线状态
        },
        setBasicInfo: {   //填写基本信息
            isUpdate:'/guider/mgmt/task/isGuiderTaskShowInfo', //判断是否存在任务详情
            add: '/guider/mgmt/task/insertGuiderTaskInfo',  //添加任务信息
            get: '/guider/mgmt/task/selectGuiderTaskInfoById', //回显任务信息
            //del:' /guider/mgmt/task/updateGuiderTaskInfo',  //删除任务信息
            update: '/guider/mgmt/task/updateGuiderTaskInfo'  //修改任务信息
        },
        setPrize: {  //设置奖品及规则
            add: '/guider/mgmt/task/insertGuiderTaskLevelInfo',
            get: '/guider/mgmt/task/selectGuiderTaskLevelInfoList',
            getLevel:'/guider/mgmt/task/selectGuiderTaskLevelById',
            del: '/guider/mgmt/task/deleteGuiderLevelInfoByLevelId',
            updateLevel: '/guider/mgmt/task/updateGuiderTaskLevelInfo',
            addTaskMark: '/guider/mgmt/task/updateGuiderTaskInfo',   //添加 任务完成标记，还有奖励任务时长两项。
            detai: '/guider/mgmt/task/selectGuiderTaskLevelInfoList'   //任务阶梯奖励列表
        },
        cashUrl:{
          batchInsertWithdrawAuditInfo:'/guider/mgmt/withdraw/batchInsertWithdrawAuditInfo',//批量添加审核原因
          batchInsertWithdrawSettlementInfo:'/guider/mgmt/withdraw/batchInsertWithdrawSettlementInfo',//批量添加结算信息
          selectWithdrawApplyInfoList:'/guider/mgmt/withdraw/selectWithdrawApplyInfoList',//提现列表
          selectGuiWithDrawApplyInfo:'/guider/mgmt/withdraw/selectGuiWithDrawApplyInfo',//根据提现id查询提现信息
          insertWithdrawAuditInfo:'/guider/mgmt/withdraw/insertWithdrawAuditInfo',//添加审核原因
          insertWithdrawSettlementInfo:'/guider/mgmt/withdraw/insertWithdrawSettlementInfo',//添加结算原因
          export:'/guider/mgmt/withdraw/export',//导出提现列表
        },
        performUrl:{
          queryTaskAchievementSummary:"/guider/mgmt/achievememt/queryTaskAchievementSummary",//任务业绩
          querySharerAchievementSummary:"/guider/mgmt/achievememt/querySharerAchievementSummary",//分享达人业绩
          queryTaskNewUser:"guider/mgmt/achievememt/queryTaskNewUser",//拉新业绩
          queryTaskOrder:"/guider/mgmt/achievememt/queryTaskOrder",//订单业绩
          exportTaskAchieveSummary:"/guider/mgmt/achievememt/exportTaskAchieveSummary",
          exportTotalAchievement:"/guider/mgmt/achievememt/exportTotalAchievement",
          exportTaskNewUser:"/guider/mgmt/achievememt/exportTaskNewUser",
          exportTaskOrder:"/guider/mgmt/achievememt/exportTaskOrder"
        }
    }
}



